import { useEffect, useRef } from 'react';
import { useTrackComponentEvent } from 'components/forms/TimePicker/hooks/useTrackComponentEvent';
import { UseFilterPresetShowTrackingProps } from '../types';

const usePrevious = (value: any): any | undefined => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const useFilterPresetShowTracking = ({
  visibleElements,
  locationPresets,
  visibilityEventType,
  scrollDirection,
}: UseFilterPresetShowTrackingProps) => {
  const trackComponentEvent = useTrackComponentEvent();
  const previousVisibleElements = usePrevious(visibleElements);

  useEffect(() => {
    const hasChanged =
      !previousVisibleElements ||
      visibleElements.size !== previousVisibleElements.size ||
      !Array.from(visibleElements).every((id) => previousVisibleElements.has(id));

    if (locationPresets?.length > 0 && visibleElements.size > 0 && hasChanged) {
      const visibleLocationPresets = locationPresets.filter((preset) => visibleElements.has(preset.id));

      const tiles_displayed = visibleLocationPresets.map((preset, index) => ({
        text: preset.label,
        id: preset.id,
        position: index + 1,
      }));

      const object_properties = {
        direction: null,
        lowest_visible_position: tiles_displayed[0]?.position || 0,
        highest_visible_position: tiles_displayed[tiles_displayed.length - 1]?.position,
        tiles_displayed,
      };

      if (visibilityEventType === 'scroll') {
        object_properties.direction = scrollDirection;
      }

      trackComponentEvent({
        event_name: visibilityEventType,
        component_type: 'group_of_controls',
        object: 'preconfigured_filter_tile_widget',
        context: 'plp',
        object_properties,
      });
    }
  }, [visibleElements, locationPresets, trackComponentEvent, previousVisibleElements]);
};

export default useFilterPresetShowTracking;
